module.exports = __webpack_public_path__ + "static/img/sec3-content-img04@t.2994b87.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec3-content-img04@t.jpg
// module id = /3aC
// module chunks = 0